import * as Sentry from '@sentry/react'

import { logAppError } from 'Helpers/logger'
import PropTypes from 'prop-types'

const ErrorBoundary = ({ children }) => {
  const handleError = (error, errorInfo) => {
    logAppError({
      appError: error,
      appErrorStack: errorInfo
    })
  }

  return (
    <Sentry.ErrorBoundary onError={handleError}>
      {children}
    </Sentry.ErrorBoundary>
  )
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
}

export default ErrorBoundary
